import { Link, useLocation } from "react-router-dom";

const tabs = [
    { path: "/account/entitlements",  label: "Entitlements" },
    { path: "/account/subscriptions", label: "Subscriptions" },
    { path: "/account/transactions",  label: "Transactions" },
];

export default function AccountTabs() {
    const here = useLocation().pathname;
    return (
        <div className="pxl-affiliate-tabs">
            <ul className="pxl-affiliate-tabs-list">
                {tabs.map(t => (
                    <li
                        key={t.path}
                        className={`pxl-affiliate-tab-item ${here.startsWith(t.path) ? "isActive" : ""}`}
                    >
                        <Link to={t.path}>{t.label}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
